/**
 * @file AnnotationsTableFormFooter.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * https://codesandbox.io/s/bn7nw?file=/demo.js:557-668
 * 
 * @author don michael
 * @since Feb 06, 2023 21:27
 */
import PropTypes from 'prop-types';

import Divider from '@mui/material/Divider'
import Pagination from '@mui/material/Pagination';

function AnnotationsTableFormFooter(props) {
    const {
        currentPageNo,
        pageCount,
        handleChange,
    } = props;

    // displays local state. updates parent state.
    const onChange = (event, value) => {
        handleChange(event, value);
    };

    return (
        <>
            <Divider sx={{ marginTop: '2px', borderBottomWidth: '4px', background: 'gray' }} />
            <Pagination count={pageCount} page={currentPageNo} shape="rounded" variant="outlined" onChange={onChange} />
        </>
    );
}

AnnotationsTableFormFooter.propTypes = {
    currentPageNo: PropTypes.number.isRequired,
    totalPageCount: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default AnnotationsTableFormFooter;
